import styles from "./SamEntityTable.module.scss";

import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
  flexRender,
} from "@tanstack/react-table";
import classNames from "classnames";

// components
import { Table } from "@trussworks/react-uswds";

// types
import { SamEntityItem } from "types/sam-entity-results";

// columns
import { columns } from "./Columns";

type ResultTableProps = {
  data: SamEntityItem[];
  rootClassname?: string;
  tableClassname?: string;
};

export default function SamEntityTable(props: ResultTableProps) {
  const { data, rootClassname, tableClassname } = props;

  const rootClass = classNames(styles["table-root"], {
    [rootClassname]: rootClassname,
  });

  const tableClass = classNames(styles["table"], {
    [tableClassname]: tableClassname,
  });

  const table = useReactTable({
    initialState: {
      sorting: [{ id: "legal_business_name", desc: false }],
      columnVisibility: {
        _rankingScore: false
      }
    },
    data,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <>
      <div className={rootClass} tabIndex={0}>
        <Table bordered className={tableClass} stackedStyle="headers">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} scope="col">
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
